import { StatusLoading } from 'common/constants/statusLoading';
import {
  FavoriteFolderData,
  FavoriteFolder,
} from 'dataSources/Typicode/favoriteCatalogs';

export interface FavoriteCatalog
  extends FavoriteFolder,
    Partial<FavoriteFolderData> {
  statusLoading: StatusLoading;
}

export interface FavoriteCatalogData {
  [key: number]: FavoriteCatalog;
}

export const STATE = 'FAVORITE_CATALOGS';
export interface IState {
  catalogs: {
    statusLoading: StatusLoading;
    data: FavoriteCatalogData;
  };
}
